<template>
    <v-card style="min-height:450px" class="pa-1">
        <v-card-title style="background:#F4F7FC;letter-spacing: .5px;;color: #1A2453;font-size: 12px;" class="py-2 subheading text-uppercase">
           <b> Sorting</b>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs6>
                    <v-autocomplete
                        :items="sortColumns"
                        class="style-input mr-2"
                        label="Columns"
                        outline
                        single-line
                        height="15px"
                        return-object
                        item-text="name"
                        item-value="id"
                        @input="addSort"
                        v-model="sortColumn"
                    />
                    <br/>
                    <v-list dense >
                        <v-list-tile
                            color="indigo"
                            v-for="(sort,index) in selectedSort"
                            :key="sort.id"
                            avatar
                            @click=""
                        >
                            <v-list-tile-content class="grey--text pa-0 ma-0">
                                <v-list-tile-title class= "body-2">
                                    <strong>
                                        {{ value[index].label }}
                                    </strong>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-switch 
                                    v-model="sort.sort"
                                   :label="sort.sort" small style="zoom:90%"
                                    true-value="Asc"
                                    false-value="Desc"
                                    @input="sortChanged"
                                />
                            </v-list-tile-action>
                        <hr/>
                        </v-list-tile>        
                    </v-list>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
import lodash from 'lodash'
export default {
    props:["value","sort"],
    data() {
        return {
            sortColumns:[],
            sortColumn:{},
            selectedSort:{},
        }
    },
    watch: {
        value() {
            this.getSortColumns()
        },
        sort() {
            this.selectedSort = Object.assign({},this.sort)
        }
    },
    created: function() {
         this.selectedSort = Object.assign({},this.sort)
        this.getSortColumns()
    },
    methods: {
         addSort() {
            if(!this.selectedSort[this.sortColumn.id]) {
                this.selectedSort[this.sortColumn.id]=this.sortColumn
                this.selectedSort[this.sortColumn.id].sort= 'Asc'
            }
            this.$emit('sortChanged',this.selectedSort)
        },
        sortChanged() {
            this.$emit('sortChanged',this.selectedSort)
        },
        getSortColumns() {
            let $parent = this 
            lodash.forEach(this.value,function($obj) {
                $parent.sortColumns.push({
                    "id":$obj.key,
                    "name":$obj.label
                })
            })
        
        }
    }
}
</script>